export default "__VITE_ASSET__DivQjf5w__"